import messagesTemplate from './messages-directive.html';
import messagesService, {message} from "./messages-service";

export default function messagesDirective() {
    const controller = function($scope: any, messages: messagesService) {
        $scope.errors = function() {
            return messages.unchecked();
        };

        $scope.checkError = function(id: number) {
            messages.check(id);
        };

        $scope.alertClass = function(msg: message) {
            return 'alert alert-' + msg.type;
        };
    };
    controller.$inject = ['$scope', 'messages'];
    return {
        restrict: 'E',
        template: messagesTemplate,
        replace: true,
        controller
    };
}
